import React from 'react';
import { useFetchResponseTimeForNode } from '../../hooks/useFetchResponseTimeForNode';
import { format } from 'date-fns';
import { api_auth } from '../../../../common/globals/constants';
import { useDynamicViewState } from '../../context/dynamic-view-context';
import { AtCircularProgress } from '../../../../components/AtCircularProgress';
import { Alert } from '@mui/material';
import { Box } from '@material-ui/core';
import { ResponseTimeForNode } from '../../../../components/IndividualCharts/ResponseTime/ResponseTimeForNode';

const URL_PARAMS = ({ objetivoId, periodo, pasoId, horarioId = '0' }) => {
  let fechaInicio = '';
  let fechaTermino = '';
  if (periodo.period === 'c') {
    fechaInicio = format(new Date(periodo.statePeriod.startDate), 'yyyy-MM-dd');
    fechaTermino = format(new Date(periodo.statePeriod.endDate), 'yyyy-MM-dd');
  }

  const token = sessionStorage.getItem('key');
  const user = sessionStorage.getItem('user');
  const URL = new URLSearchParams();
  URL.append('user', user);
  URL.append('key', api_auth);
  URL.append('token', token);
  URL.append('horarioId', horarioId);
  URL.append('objetivoId', objetivoId);
  URL.append('t', periodo.period);
  URL.append('fechaInicio', fechaInicio);
  URL.append('fechaTermino', fechaTermino);
  URL.append('pasoId', pasoId);
  return URL;
};

export const ResponseTimeForNodeChart = React.memo(
  ({ objetivoId, pasoId, horarioId }) => {
    const { filterPeriod, refreshTime } = useDynamicViewState();

    const {
      data: dataResponseTimeForNode,
      isLoading,
      error,
      isFetching,
    } = useFetchResponseTimeForNode({
      urlParams: URL_PARAMS({
        objetivoId,
        periodo: filterPeriod,
        pasoId,
        horarioId,
      }),
      fetchApi:
        filterPeriod.period === 'c'
          ? 'getDetalleRendimientoParcialPasoCustom'
          : 'getDetalleRendimientoParcialPaso',
      refreshTime,
    });

    if (isLoading || isFetching) return <AtCircularProgress />;
    if (error)
      return <Alert severity="error">Error al cargar los datos.</Alert>;

    return (
      <Box>
        <ResponseTimeForNode externalData={dataResponseTimeForNode} />
      </Box>
    );
  }
);
